import React, { Component } from "react";
import Example from "../../components/Example/Example";

import classes from "./examples.css";

class examples extends Component {
  //Make sure the user is scrolled to the top when the component is mounted.
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  //Build an object with the different bits of data that we want to show on the examples page.
  render() {
    const Examples = {
      TAD: {
        name: "Travel and Destinations",
        tech: "WordPress, HTML, CSS, PHP, jQuery",
        pType: "Live/public website",
        summary: (
          <p>
            In 2016 I started a WordPress website called Travel and
            Destinations. This website now has content designed to provide
            travel inspiration as well as travel tips. The site now gets a large
            amount of traffic (approx 100,000 users per month) from visitors all
            around the world. I spend my free time on improving the site, adding
            new and custom features, as well as adding new content. You can
            almost think of it partly as my playground. With this site I often
            go into the backend templates files to make advanced customisations
            as well as to implement new features. It has also helped me to learn
            and improve my skills and knowledge of Google Tagmanager and Google
            Analytics, including GA4.
          </p>
        ),
        linkURL: "https://www.travelanddestinations.com/",
        linkTxt: "travelanddestinations.com",
        img: "tad",
      },
      WebsitesAtPearson: {
        name: "Websites at Pearson",
        tech: "WordPress, HTML, CSS, jQuery/Javascript",
        pType: "Live/Public websites",
        summary: (
          <div>
            <p>
              Whilst working at{" "}
              <a href="https://www.pearson.com/en-gb.html">Pearson</a> I was in
              charge of maintaining and developing the various websites within
              the online learning portfolio. These are often websites which are
              used in marketing to advertise courses for their university
              partners. The websites I worked on were built with WordPress but
              with custom themes. We also used WP Bakery to speed up the build
              process of the actual landing pages as non-technical people would
              also need to build and update pages. But alongside this there was
              a lot of custom CSS, as well as php and custom elements which I
              built as well.
              <br />
              <br />
              <i>
                Note that many of these websites might have changed slightly
                since I worked for the company.
              </i>
            </p>
            <ul>
              <li>
                <a href="https://pg-online.leeds.ac.uk/">
                  pg-online.leeds.ac.uk
                </a>
              </li>
              <li>
                <a href="https://globalonline.mmu.ac.uk/">
                  globalonline.mmu.ac.uk
                </a>
              </li>
              <li>
                <a href="https://online.ulster.ac.uk/">online.ulster.ac.uk</a>
              </li>
              <li>
                <a href="https://onlinecourses.bsg.ox.ac.uk/">
                  onlinecourses.bsg.ox.ac.uk
                </a>
              </li>
              <li>
                <a href="https://onlinecourses.smithschool.ox.ac.uk/">
                  onlinecourses.smithschool.ox.ac.uk
                </a>
              </li>
              <li>
                <a href="https://study-online.sussex.ac.uk/">
                  study-online.sussex.ac.uk
                </a>
              </li>
              <li>
                <a href="https://distance-learning.northumbria.ac.uk/online-courses/cmp/surveying-msc/">
                  distance-learning.northumbria.ac.uk
                </a>
              </li>
            </ul>
          </div>
        ),
        linkURL: "#",
        readMore: "",
        linkTxt: "See above for links",
        img: "other",
      },
      BurgerBuilder: {
        name: "Burger Builder",
        tech: "React, Redux, HTML, CSS",
        pType: "Demo project",
        summary: (
          <p>
            I undertook an in depth Udemy Course so as to learn React. The
            course included 40 hours of videos and a project where we ended up
            building a Burger Builder. Aspects that were included in the course
            was the basics of React such as components, containers, state,
            passing props and imports.
            <br />
            <br />
            The course also involved using Axios to communicate with a server.
            In our case this was Axios, as well as using Redux, setting up
            automated tests, deploying to the web and more. This is hosted on
            Firebase and you can use the link below to see it.
            <br />
            <br />
            Also note I do plan on improving this demo project down the line,
            such as the styling.
          </p>
        ),
        linkURL: "https://react-my-buger-5d7df.web.app/",
        readMore: "/examples/burgerbuilder",
        linkTxt: "react-my-buger-5d7df.web.app",
        img: "burgerBuilder",
      },
      ReactQuiz: {
        name: "React Quiz",
        tech: "React, Redux, HTML, CSS",
        pType: "Demo project",
        summary: (
          <p>
            This is another React demo project which is a recode of my original
            quiz (see below) that I build in jQuery. It allows the user to pick
            from several quizzes which are setup using Javascript objects. These
            are then loaded once the user has made their selection.
            <br />
            <br />
            The app then uses Redux to manage all state such as the "question
            set" that is loaded, the current question the user is on, their
            answer to each question and other variables which drive the quiz
            functionality.
            <br />
            <br />
            At the end of the quiz the user will then see a results page which
            shows their score as the number of correct answers and a percentage.
            As well as this it highlights where they'd rank in a chart. Actually
            the chart is just dummy data for now, although if you go to my main
            jQuery quizzes mentioned further below you can see a live version
            which has had thousands of real user completes.
            <br />
            <br />
            There are still things I want to do to improve this new React quiz,
            such as adding some nav links, maybe allowing the user to continue a
            game, or change to a different quiz at another point, and
            potentially making the results table live by writing to and reading
            from a database. I'll be improving this over time during my spare
            time.
          </p>
        ),
        linkURL: "https://react-quiz-8450f.web.app/",
        linkTxt: "react-quiz-8450f.web.app",
        img: "ReactQuiz",
      },
      Quiz: {
        name: "jQuery Quizzes",
        tech: "WordPress, HTML, CSS, PHP, jQuery, Ajax",
        pType: "Live/public website",
        summary: (
          <p>
            During the Coronavirus lockdown I wanted to create a little
            something for my audience on Instagram and website to keep them
            amused. I therefore created some travel quizzes.
            <br />
            <br />
            These were programmed using jQuery to log the users answer,
            calculate their score and present a message if they missed any
            questions. Once they have completed all questions they are then put
            into a score bucket which is sent to the server using Ajax. The
            server is updated using a PHP script which saves the scores and
            completes in custom fields. Once this has happened there is an Ajax
            response with the overall counts for completions and score buckets,
            which is then used to build a chart for the user. <br />
            <br />
            This quiz was built primarily on the front-end and is just for fun,
            so it is possible for the user to cheat if they really wanted to
            look into the HTML source code.
          </p>
        ),
        linkURL:
          "https://www.travelanddestinations.com/travel-quiz-around-the-world-free-trivia-questions/",
        linkTxt:
          "www.travelanddestinations.com/travel-quiz-around-the-world-free-trivia-questions",
        img: "quiz",
      },
      MyPort: {
        name: "This website",
        tech: "React, HTML, CSS",
        pType: "Live/public website",
        summary: (
          <p>
            This website was built using React based on what I learnt through a
            Udemy course and from practicing making the Burger Builder mentioned
            above. It isn't overly complicated and uses components, containers,
            a little bit of state, ComponentWillMount, useEffect and other
            features of React. You can use the link below to go to my GitHub
            where you can see the code.
          </p>
        ),
        linkURL: "https://github.com/mikeclegg7/Online-Portfolio",
        linkTxt: "GitHub",
        img: "port",
      },
    };

    //Convert the object into an array so that we can use map later on to pass the props to the component.
    const examplesArray = [];
    for (let key in Examples) {
      examplesArray.push({
        id: key,
        example: Examples[key],
      });
    }

    //Here we create a variable with the career component using the examplesArray above.
    let exampleOutPut = (
      <div>
        {examplesArray.map((exampleElement) => (
          <div key={exampleElement.id}>
            <Example
              name={exampleElement.example.name}
              tech={exampleElement.example.tech}
              pType={exampleElement.example.pType}
              whichImg={exampleElement.example.img}
              summary={exampleElement.example.summary}
              readMore={exampleElement.example.readMore}
              linkUrl={exampleElement.example.linkURL}
              linkTxt={exampleElement.example.linkTxt}
            />
          </div>
        ))}
      </div>
    );

    //Finally return the JSX with a little intro and the output Example component created above.
    return (
      <div className={classes.Content}>
        <h1>Examples</h1>
        <p>
          Here you can find examples of the various projects I have worked on.
        </p>
        <br />
        {exampleOutPut}
      </div>
    );
  }
}

export default examples;



// WEBPACK FOOTER //
// ./src/containers/Examples/examples.jsx